export enum NotaryAppointmentRescheduleStatus {
  Pending = 'pending',
  Available = 'available',
  Unavailable = 'unavailable'
}
